import * as React from "react";
import { useState } from "react";

import { useAuth } from "../../context/AuthContext";
import { useStores } from "../../helpers";

import { styled } from "../../stitches.config";
import { bodyLarge, h2 } from "../commonStyles/Fonts";
import CloseIcon from "../assets/icons/close-cross-red-icon.svg";
import LogOutIcon from "../assets/icons/log-out-icon.svg";
import DashboardHeader from "../DashboardHeader";
import ToggleButton from "../ToggleButton";

import { logoutUser, me, deleteUser, unsubscribeZen } from "../../api/account";

import DeleteAccountModal from "./DeleteAccountModal";
import UnsubscribeModal from "./UnsubscribeModal";

const DashboardAccount: React.FC = () => {
  const { UIStore } = useStores();
  const [{ user }, dispatch] = useAuth();

  const handleLogout = () => {
    logoutUser()
      .then((res) => {
        console.log(res);
        dispatch({ type: "logout" });
        localStorage.removeItem("access_token");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleDeleteUser = async () => {
    const isDeleted = await deleteUser();

    if (isDeleted == "DELETE_NOW") {
      await logoutUser();
      localStorage.removeItem("access_token");
    }

    return isDeleted;
  };

  const [showDeleteModal, openDeleteModal] = useState<boolean>(false);
  const [showUnsubscribeModal, openSubscribeModal] = useState<boolean>(false);

  const [isSubscribed, setSubscribtion] = useState<boolean>((!user || !user.valid) ? false : true);

  const unsubscribe = async () => {
    try {
      const state = await unsubscribeZen();

      if (state)
        setSubscribtion(false);
      else
        return false;

    } catch {
      return false;
    }
    return true;
  }

  return (
    <StyledDashboardWrapper id="konto">
      <h2 className={h2()}>Konto</h2>
      <DashboardBoxWrapper>
        <DashboardHeader
          description={
            "Twoje naTemat pozwala Ci na korzystanie z naTemat bez reklam display oraz dodatkowych funkcjonalności jak personalizacja Strony Głównej. Dzięki Twojemu wsparciu, możemy dostarczać Ci codzienne informacje i autorskie materiały."
          }
          title={"Twoje naTemat"}
          btnText={""}
          btnActive={false}
        />
        <ToggleButton
          text={"Twoje naTemat"}
          active={isSubscribed}
          onToggle={() => isSubscribed ? openSubscribeModal(true) : UIStore.setShowLoginModal(true)}
          autoToggle={false}
        />
        <DashboardTable className={bodyLarge()}>
          Twój e-mail: {user?.email}
          <br />
          Subskrybcja: {user?.valid
            ? "aktywna do " + user?.valid_to
            : "nieaktywna"}
        </DashboardTable>
      </DashboardBoxWrapper>
      <UnsubscribeModal
        open={showUnsubscribeModal}
        onCloseBtn={() => openSubscribeModal(false)}
        onUnsubscribeBtn={unsubscribe}
      />
      <br />
      <DashboardTableFooter className={bodyLarge()}>
        <button onClick={handleLogout} className="log-out">
          Wyloguj się<span></span>
        </button>
        <button onClick={() => openDeleteModal(true)} className="delete">
          Usuń konto<span></span>
        </button>
      </DashboardTableFooter>
      <DeleteAccountModal
        open={showDeleteModal}
        onCloseBtn={() => openDeleteModal(false)}
        onDeleteBtn={handleDeleteUser}
      />
    </StyledDashboardWrapper>
  );
};

const StyledDashboardWrapper = styled("div", {
  "& h2": {
    color: "$grayscale90",
    margin: "0 16px 16px 16px",
    "@bp4": {
      margin: "0 0 16px 0",
    },
  },
  "& p": {
    margin: "0 16px 24px 16px",
    color: "$grayscale75",
    "@bp4": {
      margin: "0 0 24px 0",
    },
  },
});

const DashboardBoxWrapper = styled("div", {
  background: "$grayscale0",
  padding: "0px 36px 24px 16px",
  "@bp4": {
    padding: "0px 52px 24px 32px",
  },
  "& p": {
    margin: 0,
    color: "$grayscale100",
  }
});

const DashboardTable = styled("div", {
  width: "100%",
  background: "$grayscale0",
  color: "$grayscale100",
  display: "flex",
  justifyContent: "space-between",
  marginTop: "24px",
});

const DashboardTableFooter = styled("div", {
  padding: "32px 36px 24px 16px",
  width: "100%",
  background: "$grayscale0",
  color: "$grayscale100",
  display: "flex",
  justifyContent: "space-between",
  "@bp4": {
    padding: "24px 52px 24px 32px",
  },
  "& button": {
    background: "none",
    borderWidth: "0px",
    cursor: "pointer",
    position: "relative",
    "& span": {
      width: "14px",
      height: "14px",
      backgroundImage: `url("${LogOutIcon}")`,
      backgroundSize: "cover",
      content: "",
      position: "absolute",
      top: "5px",
      margin: "0 0 0 6px",
    },
  },
  "& .log-out": {
    color: "$grayscale75",
    "& span": {
      backgroundImage: `url("${LogOutIcon}")`,
    },
  },
  "& .delete": {
    color: "$aszdziennikPrimary",
    "& span": {
      backgroundImage: `url("${CloseIcon}")`,
    },
  },
});

export default DashboardAccount;
